if (!customElements.get('notify-back-in-stock-modal')) {
  customElements.define(
    'notify-back-in-stock-modal',
    class NotifyBackInStockModal extends ModalDialog {
      constructor() {
        super();
        this.onSubmit = this.onSubmit.bind(this);
        this.submitButton = this.querySelector('[type="submit"]');
        this.successMessage = this.querySelector('.notify-modal__success-text');
        this.variantSelector = this.querySelector('.notify-modal__selector');
        this.errorMessageWrapper = this.querySelector('.notify-form__error-message-wrapper');
      }

      connectedCallback() {
        if (super.connectedCallback) super.connectedCallback();

        const form = this.querySelector('form');
        if (form && !form._notifyListenerAttached) {
          form.addEventListener('submit', this.onSubmit);
          form._notifyListenerAttached = true;
        }
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        const currentId = this.getCurrentVariantId();
        if (currentId && this.variantSelector) {
          this.variantSelector.value = currentId;
        }

        if (!this.errorMessageWrapper.classList.contains('hidden')) this.errorMessageWrapper.classList.add('hidden');
        this.submitButton.setAttribute('aria-disabled', false);
        this.submitButton.classList.remove('loading');
        this.submitButton.classList.remove('hidden');
        this.successMessage.classList.add('hidden');
      }

      getCurrentVariantId() {
        const form = document.querySelector('form[action*="/cart/add"]');
        const idInput = form?.querySelector('input[name="id"]');
        return idInput?.value ? String(idInput.value) : null;
      }

      async onSubmit(event) {
        event.preventDefault();

        if (!this.errorMessageWrapper.classList.contains('hidden')) this.errorMessageWrapper.classList.add('hidden');
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

        const form = event.currentTarget;
        const formData = new FormData(form);

        const payload = {};
        for (const [key, value] of formData.entries()) payload[key] = value;
        if (!payload['variant_id']) {
          payload['variant_id'] = payload['product_id']
        }
        delete payload.product_id

        try {
          const response = await fetch('/apps/back-in-stock/subscribe', {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(payload)

          });

          if (!response || !response.ok) {
            this.handleErrorMessage();
          } else {
            this.submitButton.classList.remove('loading')
            this.submitButton.classList.add('hidden');
            this.successMessage.classList.remove('hidden');
            this.querySelector('.loading-overlay__spinner').classList.add('hidden');
          }
        } catch (e) {
          this.handleErrorMessage(error);
        }
      }

      handleErrorMessage(error = '') {
        console.error(error)
        if (!this.errorMessageWrapper) return;

        this.errorMessageWrapper.classList.remove('hidden');
        this.submitButton.classList.remove('loading');
        this.submitButton.setAttribute('aria-disabled', false);
        this.querySelector('.loading-overlay__spinner').classList.add('hidden');
      }
    }
  );
}